import { HorizontalSafeAreaContainer } from '../../../../components';
import { CreditAddScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <CreditAddScreen />
    </HorizontalSafeAreaContainer>
  );
}
